<template>
    <div class="page-container">
        
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >

            <ul class="video-render-box">
                <li class="vide-render-item-box"  v-for="(item, index) in list" :key="index" >
                    <div class="video-image">
                        <video class="video" controls :poster="item.smallImage" webkit-playsinline="true" x-webkit-airplay="true"  playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" >
                            <!-- <source src="https://csrc.vcloud.dogecdn.com/vcloud/17/v/20190424/1556036075_818c4125ec9c8cbc7a7a8a7cc1601512/1037/7d515b22c4958598c0fbd1e6290a5ca5.mp4?vkey=8619531E3184AE4DFFC2FC085AB40A6488C000F0616BA888855F0550AB21FAD99F2CCE631621EAE2BB974281017E0187FEA8D7FCA91F96E2042DFF4473E6AC5F4FF83623E5D73859B2B3FBDF01BB6066B452613048BB6CE8E2F598E69ABB9AC4E7A03AE60C598AC56AA55ACE7150066EDC58850FF511CB7EE14AA5CE76BE4C1557AD46546874FDA97C759055546DA4E7&tkey=1594192175312f7fce88&auth_key=1594206575-HBqxnNalpQMfvCoT-0-221df9bb1eedf56530317924c056c5d3" type="video/mp4"> -->
                            <!-- <source src="https://csrc.vcloud.dogecdn.com/vcloud/17/v/20190424/1556036075_818c4125ec9c8cbc7a7a8a7cc1601512/1037/7d515b22c4958598c0fbd1e6290a5ca5.mp4?vkey=8619531E3184AE4DFFC2FC085AB40A6488C000F0616BA888855F0550AB21FAD99F2CCE631621EAE2BB974281017E0187FEA8D7FCA91F96E2042DFF4473E6AC5F4FF83623E5D73859B2B3FBDF01BB6066B452613048BB6CE8E2F598E69ABB9AC4E7A03AE60C598AC56AA55ACE7150066EDC58850FF511CB7EE14AA5CE76BE4C1557AD46546874FDA97C759055546DA4E7&tkey=1594192175312f7fce88&auth_key=1594206575-HBqxnNalpQMfvCoT-0-221df9bb1eedf56530317924c056c5d3" type="video/ogg"> -->
                            <!-- <source src="https://csrc.vcloud.dogecdn.com/vcloud/17/v/20190424/1556036075_818c4125ec9c8cbc7a7a8a7cc1601512/1037/7d515b22c4958598c0fbd1e6290a5ca5.mp4?vkey=8619531E3184AE4DFFC2FC085AB40A6488C000F0616BA888855F0550AB21FAD99F2CCE631621EAE2BB974281017E0187FEA8D7FCA91F96E2042DFF4473E6AC5F4FF83623E5D73859B2B3FBDF01BB6066B452613048BB6CE8E2F598E69ABB9AC4E7A03AE60C598AC56AA55ACE7150066EDC58850FF511CB7EE14AA5CE76BE4C1557AD46546874FDA97C759055546DA4E7&tkey=1594192175312f7fce88&auth_key=1594206575-HBqxnNalpQMfvCoT-0-221df9bb1eedf56530317924c056c5d3" type="video/webm"> -->
                            <source :src="item.video" type="video/mp4">
                            <source :src="item.video" type="video/ogg">
                            <source :src="item.video" type="video/webm">
                            您的浏览器不支持 video 标签。
                        </video>
                    </div>
                    <div class="video-name ellipsis">{{item.title}}</div>
                </li>
            </ul>

        </van-list>


    </div>
</template>

<script>
    import {getAllNewsUrl} from '@culturalRelicsUrl';
    import http from '@js/http-ww.js'
    import { List } from 'vant';
    export default {
        data() {
            return {
                //  直播
                requestParams:{
                    nodeId: 266,
                    page: -1,
                    size: 10,
                },

                loading: false,
                finished: false,

                list: []
            }
        },

        created() {
        },

        methods: {

            onLoad() {
                this.getVideList()
            },

            getVideList() {
                this.requestParams.page++
                http.get(getAllNewsUrl, {params:{...this.requestParams}, loading: !(this.list.length > 0) } )
                .then(res=>{
                    this.loading = false;
                    var {
                        data: {
                            data: {
                                page: {
                                    content: list = []
                                }
                            }
                        }
                    } = res
                    if(list.length > 0){
                        list.forEach(item => {
                            item.video = `${window._api_newsBase}${item.video}`
                        });
                        this.list = this.list.concat(list)
                    }else{
                        this.finished = true;
                    }
                })
            },
        },

        components: {
            [List.name]: List
        }

    }
</script>

<style lang="less" scoped>
    .red{
        border: 1px solid red;
    }
    .page-container{
        padding: 10px 10px 0;
        .video-render-box{
            .vide-render-item-box{
                height: 240px;
                border-radius: 8px;
                margin-bottom: 10px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                background-color: #ffffff;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                &:last-of-type{
                    margin-bottom: 0;
                }
                .video-image{
                    flex: 1;
                    overflow: hidden;
                    .image{
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
                .video{
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit:fill;
                    border-top-left-radius: 8px;
                    border-top-right-radius: 8px;
                }
                .video-name{
                    // .red();
                    border-top: 1px solid #f0f1f4;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(99,99,99,1);
                    padding: 12px 10px 16px;
                }
            }
        }
    }
</style>